import * as prelude from '#gleam/prelude'

export function clickUploadAttachment() {
  document.getElementById('projects-show-questionnaire-upload')?.click()
}

export function innerText(event: Event) {
  const target = event.target as HTMLElement
  const text = target.innerText
  return new prelude.Ok(text)
}
